import { useEffect, useRef } from 'react'

import { TextField } from '@material-ui/core'

import { ERROR_MESSAGES } from '../../components/ContentModal/components/constants'

type CharacterLimitInputProps = {
  value: string
  label: string
  placeholder: string
  charLimit?: number
  field: string
  id: string
  onUpdateField: (field: string, value: string) => void
  validation?: {
    setError: (label: string, error: string) => void
    clearErrors: (labels: string[]) => void
    getHasError: (label: string) => boolean
  }
  setError?: (error: boolean) => void
}

const CharacterLimitInput = ({
  value,
  field,
  label,
  placeholder,
  charLimit = 60,
  id,
  onUpdateField,
  validation,
  setError,
}: CharacterLimitInputProps) => {
  const touchedRef = useRef(false)
  const touched = touchedRef.current
  const error = touched && (validation ? !!validation.getHasError(label) : value?.length > charLimit)

  useEffect(() => {
    if (setError) {
      setError(error)
    }
  }, [error, setError])

  return (
    <TextField
      id={id}
      fullWidth
      multiline
      variant="outlined"
      label={label}
      placeholder={placeholder}
      value={value}
      helperText={
        value?.length > 0 ? `${charLimit - value?.length} characters left` : `Enter up to ${charLimit} characters`
      }
      error={error}
      onChange={(e) => {
        touchedRef.current = true
        if (validation) {
          if (e.target.value.length > charLimit) {
            validation.setError(label, ERROR_MESSAGES.VALID_LENGTH)
          } else {
            if (error) {
              validation.clearErrors([label])
            }
          }
        }
        onUpdateField(field, e.target.value)
      }}
    />
  )
}

export default CharacterLimitInput
